export function formatImage(path: string): string {
  return `${process.env.REACT_APP_ASSETS_DOMAIN}${path}`;
}

export function getArrayKeyByValue<T extends Record<string, unknown>>(object: T, value: string): string | undefined {
  return Object.keys(object).find((key) => object[key] === value);
}
